import React from "react";
import { CircleCheckIcon, DownloadIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CollectionMockup } from "./CollectionMockup";
import { PurchaseButton } from "./PurchaseButton";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { includedItems } from "../data/landing";
import { ctaMicrocopy, offer, productVisuals } from "../data/offer";
const trustItems = [{
  icon: LockIcon,
  title: "Secure Payment",
  text: "Encrypted checkout"
}, {
  icon: DownloadIcon,
  title: "Instant Digital Access",
  text: "Sent to your email"
}, {
  icon: ShieldCheckIcon,
  title: "7-Day Guarantee",
  text: "Money-back protection"
}];
export function OfferSection() {
  return <section id="offer" className="bg-navy" data-id="element-166" data-mp="wchfwqunu0gw">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-167" data-mp="2t59ldip79spk">
        <SectionHeading tone="light" eyebrow="Your Complete Faith Resource — Special Offer" title={<>
              Get Everything Inside WHY WE BELIEVE for Just <span className="text-gold" data-id="element-169" data-mp="12o1x37kq5aa5">{offer.price}</span> Today.
            </>} data-id="element-168" data-mp="2t745iusndgsl" />

        <div className="mt-12 grid gap-10 rounded-[2rem] bg-white p-6 md:p-10 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-170" data-mp="xx1y7ws1oi50">
          <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-171" data-mp="sx78hwk09ylj">
            <CollectionMockup src={productVisuals.offerMockup} data-id="element-172" data-mp="svcl8bl9huea" />
          </div>

          <div data-id="element-173" data-mp="oxyfitwsi4r1">
            <h3 className="font-display text-xl font-extrabold text-ink" data-id="element-174" data-mp="ouajno3vh695">What's Included:</h3>
            <ul className="mt-4 space-y-2.5" data-id="element-175" data-mp="1lka1k95wxh4e">
              {includedItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink" data-id="element-176" data-mp="1gnt3on8wvoe4">
                  <CircleCheckIcon className="mt-px h-5 w-5 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-177" data-mp="1ck4u5z0pyiq8" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 rounded-2xl bg-canvas px-6 py-7 text-center" data-id="element-178" data-mp="17khmmrixboj">
              <p className="text-sm font-semibold uppercase tracking-wider text-ink-soft" data-id="element-179" data-mp="3scavjecjtvs1">
                Regular Price: <s data-id="element-180" data-mp="3ttq24lczy7ii">{offer.regularPrice} {offer.currency}</s>
              </p>
              <p className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-royal" data-id="element-181" data-mp="2ng946i1xiet">
                Today's Special Price
              </p>
              <p className="mt-1 font-display font-extrabold leading-none text-navy" data-id="element-182" data-mp="3kve1dqif1tcc">
                <span className="text-7xl md:text-8xl" data-id="element-183" data-mp="3otbu33beaxkh">{offer.price}</span>
                <span className="ml-2 text-xl" data-id="element-184" data-mp="3b2gp4240p0m6">{offer.currency}</span>
              </p>
              <span className="mt-4 inline-block rounded-full bg-leaf-light px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-leaf" data-id="element-185" data-mp="3fuhxve1z897g">
                Save {offer.savings}!
              </span>
            </div>

            <div className="mt-6" data-id="element-186" data-mp="364onggdkm04s">
              <PurchaseButton label={`Yes! I Want the Complete Bundle for ${offer.price}`} data-id="element-187" data-mp="2s4nl0whnqkn7" />
              <CtaMicrocopy items={ctaMicrocopy.offer} data-id="element-188" data-mp="2x3qt6psxp6ze" />
            </div>
          </div>

          <ul className="grid gap-4 border-t border-ink/10 pt-8 sm:grid-cols-3 lg:col-span-2" data-id="element-189" data-mp="2x5jqhehnqeuq">
            {trustItems.map(({
            icon: Icon,
            title,
            text
          }) => <li key={title} className="flex items-center gap-3" data-id="element-190" data-mp="28kykiy5exuwk">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-royal-light" data-id="element-191" data-mp="2mjepoknmndcl">
                  <Icon className="h-5 w-5 text-royal" aria-hidden="true" data-id="element-192" data-mp="2ifqg5wffq7op" />
                </span>
                <span data-id="element-193" data-mp="2wf86ig8dpt06">
                  <span className="block font-display text-[15px] font-bold text-ink" data-id="element-194" data-mp="2wegetghwkff6">{title}</span>
                  <span className="block text-sm text-ink-soft" data-id="element-195" data-mp="2rfvme38w701a">{text}</span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}